import React, { useEffect, useState } from "react"
import BackgroundAuthentication from "../../components/Lystface/Common/BackgroundAuthentication"
import LoginForm from "../../components/Lystface/Login/LoginForm"
import { appConstants } from "../../constants/app_constants"
import withRouter from "../../components/Common/withRouter"
import { LoginUserReset, ResendRegisterUser, resetRegisterResponseMsg } from "../../store/actions"
import { useDispatch, useSelector } from "react-redux"
import VerificationHelper from "../../components/Lystface/Common/VerificationHelper"
import VerifylinkResendLayout from "../../components/Lystface/Helper/Verification/VerifylinkResendLayout"
import OtopAuthenticationLogo from "../../../src/assets/images/lystfacelogos/OtpAuthenticationLogo.svg"
import { isNotNullOrUndefined, maskPhoneNumber } from "../../common/functions"
import { resendLoginOtp, resendOtp, resetResendOtpResponseMsg, sendEmail } from "../../store/menu/application/actions"
import { Helmet } from "react-helmet"

const Login = props => {
  document.title = `Login | ${appConstants.cName}`
  const SignupState = useSelector(state => state.Account)
  const { plan_id: planId } = SignupState
  const LoginUserState = useSelector(state => state.Login)
  const { twoFactor, email, userpswd, cmp_phone_code, cmp_phone, dailcode, loginError, loginStatus, loginErrorType } = LoginUserState
  const [sendingFrom, setSendingFrom] = useState(null)
  const [tryOtherOptions, setTryOtherOptions] = useState(false)
  const dispatch = useDispatch();
  const { registrationError, registrationErrorMessage, from } = SignupState
  const AccountSetting = useSelector(state => state.Application);
  const { resendLoginOtp: { loading: resendLoginOtpLoading, error: resendLoginOtpError, from: resendLoginOtpedFrom, responseMessage: resendLoginOtpResponseMessage } } = AccountSetting



  useEffect(() => {
    if (!registrationError && isNotNullOrUndefined(registrationErrorMessage) && loginErrorType !== "email_not_verfied") {
      setTryOtherOptions(false)
      setSendingFrom("other-email")
    }
    if (!resendLoginOtpError && isNotNullOrUndefined(resendLoginOtpResponseMessage)) {
      setTryOtherOptions(false)
      setSendingFrom("other-phone")
    }
  }, [registrationError, registrationErrorMessage, resendLoginOtpError, resendLoginOtpResponseMessage, loginError, loginStatus, loginErrorType])


  const handleClickTryOtherOptions = (value) => {
    setTryOtherOptions(value)
  }

  const handleSendingFrom = (from) => {
    if (from === "other-phone") {
      const payload = {
        login: false,
        cmp_phone_code: cmp_phone_code,
        cmp_phone: cmp_phone,

      }
      dispatch(resendLoginOtp(payload, "send"))

    }
    else {
      const payload = {
        email: email,
        login: true

      }
      dispatch(ResendRegisterUser(payload))
    }

  }

  return (
    <div>
      <Helmet>
        <link rel="icon" href="https://img-assets.lystface.com/web/logo/logoSm.svg" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="description"
          content="Log in to your Lystface account to access our face recognition API. Manage your integrations, monitor usage, and explore advanced features securely." />
        <meta property="og:image" content="https://img-assets.lystface.com/web/logo/logoSm.svg" />
        <link rel="apple-touch-icon" href="https://img-assets.lystface.com/web/logo/logoSm.svg" />
        <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
        <title>Login to {appConstants.cName} | Secure Face Recognition API Access</title>

      </Helmet>
      {
        sendingFrom === "other-email" ?
          <BackgroundAuthentication Image={true} form={<VerifylinkResendLayout title="OTP authentication" from="other-email" email={email} handleClickTryOtherOptions={handleClickTryOtherOptions}
            setSendingFrom={handleSendingFrom}
            tryOtherOptions={tryOtherOptions}
            setSendFromStatus={setSendingFrom}

          />} />
          :
          (loginErrorType === "email_not_verfied") ?
            <BackgroundAuthentication Image={true} form={<VerifylinkResendLayout from="login-unverfied" email={email} pswd={userpswd} />} />
            :
            twoFactor ?
              <BackgroundAuthentication Image={true} form={<VerifylinkResendLayout
                title="OTP authentication"
                message={<div>Enter the OTP sent to number ending with {dailcode} {maskPhoneNumber(cmp_phone)}.</div>}
                logo={OtopAuthenticationLogo}
                from="verify-phone"
                checkboxContent="Remember me for 30 days in this browser."
                email={email}
                cmp_phone_code={cmp_phone_code}
                phone={cmp_phone}
                setSendingFrom={handleSendingFrom}
                tryOtherOptions={tryOtherOptions}
                handleClickTryOtherOptions={handleClickTryOtherOptions}
                setSendFromStatus={setSendingFrom}

              />} />
              :
              <BackgroundAuthentication Image={true} form={<LoginForm />} />


      }

    </div>
  )
}

export default withRouter(Login)
